import SpriteSymbol from "../../../node_modules/svg-baker-runtime/browser-symbol.js";
import sprite from "../../../node_modules/svg-sprite-loader/runtime/browser-sprite.build.js";
var symbol = new SpriteSymbol({
  "id": "icon-zgj",
  "use": "icon-zgj-usage",
  "viewBox": "0 0 287 159",
  "content": "<symbol xmlns=\"http://www.w3.org/2000/svg\" viewBox=\"0 0 287 159\" id=\"icon-zgj\">\r\n  <g id=\"icon-zgj_筑工匠\" transform=\"translate(-798 -131)\">\r\n    <text id=\"icon-zgj_筑\" transform=\"translate(798 248)\" fill=\"#fff\" font-size=\"117\" font-family=\"34--Regular, 字魂34号-少年和风体\" letter-spacing=\"0.001em\"><tspan x=\"0\" y=\"0\">筑</tspan></text>\r\n    <text id=\"icon-zgj_工\" transform=\"translate(886 267)\" fill=\"#fff\" font-size=\"117\" font-family=\"34--Regular, 字魂34号-少年和风体\" letter-spacing=\"0.001em\"><tspan x=\"0\" y=\"0\">工</tspan></text>\r\n    <text id=\"icon-zgj_匠\" transform=\"translate(968 248)\" fill=\"#fff\" font-size=\"117\" font-family=\"34--Regular, 字魂34号-少年和风体\" letter-spacing=\"0.001em\"><tspan x=\"0\" y=\"0\">匠</tspan></text>\r\n  </g>\r\n</symbol>"
});
var result = sprite.add(symbol);
export default symbol


//////////////////
// WEBPACK FOOTER
// ./src/icons/svg/zgj.svg
// module id = B73K
// module chunks = 1